import React, { useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { SecondaryButtonInline, NamedRedirect } from '../../../components';
import { ReactComponent as TickIcon } from './tickIcon.svg';
import { ReactComponent as NewCartIcon } from '../../Topbar/CartComponent/newCartIcon.svg';
import css from './AddToCartBtn.module.css';

const AddToCartBtn = (props) => {
    const {
        onAddToCart,
        isSuccess,
        addToCartDisabled,
        shouldCartRedirectToSignup,
        withError,
        inProgress,
    } = props;

    const [redirectionActive, setRedirectionActive] = useState(false);

    if (redirectionActive) {
        return <NamedRedirect
            name='SignupPage'
            state={{ from: `${location.pathname}${location.search}${location.hash}` }}
        />
    };

    return <div className={css.root}>
        <SecondaryButtonInline
            type="button"
            inProgress={inProgress}
            disabled={addToCartDisabled || isSuccess || inProgress}
            className={`${css.cartBtn} ${isSuccess && css.cartBtnSuccess}`}
            onClick={() => {
                if (shouldCartRedirectToSignup) {
                    setRedirectionActive(true);
                } else {
                    onAddToCart();
                };
            }}
        >
            <FormattedMessage id={`AddToCartBtn.${isSuccess ? 'added' : 'add'}ToCart`} />
            {isSuccess ? <TickIcon /> : <NewCartIcon />}
        </SecondaryButtonInline>

        {withError ? <div className={css.error}>
            <FormattedMessage id="AddToCartBtn.datesError" />
        </div> : null}
    </div>
};

export default AddToCartBtn;
